<div class="ocr-container">
    <h2>Meter OCR Reader</h2>
  
    <!-- File Upload -->
    <input type="file" accept="image/*" (change)="onFileSelected($event)" />
  
    <!-- Image Enhancement Controls -->
    <div class="controls">
      <label>
        Threshold: {{ threshold }}
        <input
          type="range"
          min="0"
          max="255"
          [value]="threshold"
          (input)="updateThreshold($any($event.target).value)"
        />
      </label>
  
      <label>
        <input
          type="checkbox"
          [checked]="invert"
          (change)="toggleInvert()"
        />
        Invert Colors
      </label>
    </div>
  
    <!-- Loading Indicator -->
    <div *ngIf="loading" class="loading">
      <p>Reading meter... Please wait.</p>
    </div>
  
    <!-- Image Preview -->
    <div *ngIf="imageUrl && !loading" class="preview">
      <h3>Image Preview:</h3>
      <img [src]="imageUrl" alt="Selected image" style="max-width: 100%; border: 1px solid #ccc;" />
    </div>
  
    <!-- OCR Result -->
    <div *ngIf="ocrResult && !loading" class="result">
      <h3>OCR Result:</h3>
      <p><strong>{{ ocrResult }}</strong></p>
    </div>
  </div>
  